var _path, _circle, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 116,
    viewBox: "0 0 202 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.476 30.5001C115.976 8 67.9763 3.92166 67.9763 3.92166",
    stroke: "#0088FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 58,
    r: 58,
    fill: "#FF8BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 36C102 49.2548 99 60 99 60C99 60 96 49.2548 96 36C96 22.7452 99 12 99 12C99 12 102 22.7452 102 36Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7302 69.9846C91.453 63.2617 99.0243 59.9331 99.0243 59.9331C99.0243 59.9331 95.6957 67.5044 88.9728 74.2272C82.25 80.9501 74.6787 84.2787 74.6787 84.2787C74.6787 84.2787 78.0073 76.7074 84.7302 69.9846Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.476 98C74.9763 115 -55.5238 80.0001 27.4762 62.0001C31.8259 61.0568 36.339 60.2659 40.9763 59.6138M155.976 46.8064C199 46.8064 218.696 64.7869 181.976 64.0001C111.976 62.5001 24.4763 32.2003 24.4763 14.0001C24.4763 5.42755 41.9933 1.77421 67.9763 3.92165",
    stroke: "#0088FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f25b8936d884d09282e0d8d8ff8ecb77.svg";
export { ForwardRef as ReactComponent };